module.exports = __webpack_public_path__ + "4381bd55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram/Storytape-3.jpg
// module id = 1267
// module chunks = 1 4